/* eslint-disable react/require-default-props */
import { forwardRef } from 'react';
import Link from 'next/link';
import { OpenInNew } from 'components/ui/atoms/icons/OpenInNew';

export type HyperlinkProps = {
  destination?: string;
  children: React.ReactNode;
  className?: string;
  target?: string;
  rel?: string;
  showLaunchIcon?: boolean;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const Hyperlink = forwardRef<HTMLAnchorElement, HyperlinkProps>(
  (
    {
      destination = '',
      children,
      className = '',
      target = '',
      rel = '',
      showLaunchIcon = true,
      ...props
    },
    ref,
  ) => {
    const isExternal = target === '_blank';
    const finalRel = isExternal ? (rel ?? 'noopener noreferrer') : rel;
    const finalDestination = destination ?? '';

    return (
      <Link
        ref={ref}
        href={finalDestination}
        className={className}
        target={target}
        rel={finalRel}
        {...props}
      >
        {children}
        {isExternal && showLaunchIcon && (
          <span className="ml-1 d-inline-flex align-items-end">
            <OpenInNew svgProps={{ style: { width: 16, height: 16 } }} />
          </span>
        )}
      </Link>
    );
  },
);

Hyperlink.displayName = 'Hyperlink';
